module.exports = __webpack_public_path__ + "img/img-entp.3d3b147d.jpg";